/**
 * Touch / pointer swipe for Amose product galleries (main image + thumbnails).
 * Initializes on [data-amose-gallery-swipe] roots.
 */
(function () {
  'use strict';

  var TRANSITION = 'transform 0.38s cubic-bezier(0.22, 1, 0.36, 1)';
  var SWIPE_RATIO = 0.18;
  var DRAG_START = 8;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * @param {HTMLElement} root
   */
  function initGallery(root) {
    if (root.dataset.amoseGalleryInit === '1') return;

    var viewport = root.querySelector('[data-amose-gallery-viewport]');
    var track = root.querySelector('[data-amose-gallery-track]');
    if (!viewport || !track) return;

    var slides = Array.prototype.filter.call(track.children, function (node) {
      return node.nodeType === 1;
    });

    if (!slides.length) return;

    root.dataset.amoseGalleryInit = '1';

    var index = 0;
    var width = 0;
    var dragging = false;
    var startX = 0;
    var startTranslate = 0;
    var currentTranslate = 0;
    /** @type {number | null} */
    var pointerId = null;

    function measure() {
      width = viewport.offsetWidth || 1;
    }

    function setTranslate(x, instant) {
      currentTranslate = x;
      track.style.transition =
        instant || dragging || prefersReducedMotion() ? 'none' : TRANSITION;
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }

    function emitChange() {
      var slide = slides[index];
      root.dispatchEvent(
        new CustomEvent('amose-gallery:change', {
          bubbles: true,
          detail: {
            index: index,
            slide: slide,
            mediaId: slide ? slide.getAttribute('data-media-id') : null,
          },
        })
      );
    }

    function goTo(i, opts) {
      opts = opts || {};
      index = Math.max(0, Math.min(slides.length - 1, i));
      measure();
      setTranslate(-index * width, !!opts.instant);
      if (!opts.silent) emitChange();
    }

    function goToMediaId(id, opts) {
      if (id == null) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(id)) {
          goTo(i, opts);
          return;
        }
      }
    }

    root.amoseGallery = {
      goTo: goTo,
      goToMediaId: goToMediaId,
      getIndex: function () {
        return index;
      },
      getSlideCount: function () {
        return slides.length;
      },
    };

    if (slides.length <= 1) {
      goTo(0, { instant: true, silent: true });
      return;
    }

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        goTo(index, { instant: true, silent: true });
      });
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', function () {
        goTo(index, { instant: true, silent: true });
      });
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      measure();
      dragging = false;
      startX = e.clientX;
      startTranslate = -index * width;
      pointerId = e.pointerId;
      viewport.setPointerCapture(e.pointerId);
    }

    function onPointerMove(e) {
      if (e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > DRAG_START) {
        dragging = true;
        track.classList.add('is-dragging');
        root.setAttribute('data-amose-gallery-dragging', '');
      }
      if (!dragging) return;
      e.preventDefault();

      var next = startTranslate + dx;
      var min = -(slides.length - 1) * width;
      var max = 0;
      if (next > max) next = max + (next - max) * 0.35;
      else if (next < min) next = min + (next - min) * 0.35;
      setTranslate(next, true);
    }

    function onPointerEnd(e) {
      if (e.pointerId !== pointerId) return;
      try {
        viewport.releasePointerCapture(pointerId);
      } catch (err) {
        /* ignore */
      }
      pointerId = null;
      track.classList.remove('is-dragging');
      root.removeAttribute('data-amose-gallery-dragging');

      if (!dragging) return;
      dragging = false;

      var dx = e.clientX - startX;
      var target = index;
      if (Math.abs(dx) > width * SWIPE_RATIO) {
        target = dx < 0 ? index + 1 : index - 1;
      } else {
        target = Math.round(-currentTranslate / width);
      }
      goTo(target);
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove, { passive: false });
    viewport.addEventListener('pointerup', onPointerEnd);
    viewport.addEventListener('pointercancel', onPointerEnd);

    goTo(0, { instant: true, silent: true });
  }

  function scan() {
    document.querySelectorAll('[data-amose-gallery-swipe]').forEach(initGallery);
  }

  window.AmoseGallerySwipeInit = initGallery;
  window.AmoseGallerySwipeRescan = scan;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
